import React from "react";
import OrderLayout from "./Components/OrderLayout";

const Order = () => {
  return <OrderLayout />;
};

export default Order;
